// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../revvComponents";

// Components Imports

// Actions Imports
import {
  getDocumentSettingsAction,
  updatedDocumentSettingsAction,
} from "../../actions/DocumentActions";
import { QuotationActions } from "../../actions";

// SERVICE Imports

// Internal Imports

// Destructuring
const { updateToolPaneData } = QuotationActions;

class DocumentForwardingSetting extends Component {
  constructor(props) {
    super(props);
    this.state = { confirm: false };
  }

  componentDidMount = () => {
    this.props.getDocumentSettingsAction(this.props.docID).then(res => {
      res.forEach(item => {
        if (item.name === "DOCUMENT_FORWARDING") {
          this.setState({ confirm: item.is_enabled });
        }
      });
    });
  };

  _toggleCheckbox = () => {
    this.setState(prevState => ({ confirm: !prevState.confirm }));
    const data = {
      is_enabled: !this.state.confirm,
      name: "DOCUMENT_FORWARDING",
    };
    this.props
      .updatedDocumentSettingsAction(this.props.docID, data)
      .then(res => {
        if (res.name === "DOCUMENT_FORWARDING") {
          this.setState({ confirm: res.is_enabled });
        }
      });
  };

  render() {
    return (
      <div className="documentforwardingsetting-wrapper">
        <div className="documentsettings-subheader">
          <FontAwesomeIcon
            icon={["far", "share"]}
            className="documentsettings-icon"
          />
          <span className="documentsettings-title">Document Forwarding</span>
          <span className="recipient-side-documentsettings-toggle-btn">
            <Input
              className="docsharingpopup-sharingform-col"
              isSwitch
              type="checkbox"
              onChange={() => this._toggleCheckbox()}
              value=""
              checked={this.state.confirm}
              data-test="addreviewerssection-edit-checkbox"
            />
          </span>
        </div>
        <div className="documentsettings-upload-message-section">
          <span>
            {" "}
            Recipients will be able to send the document to other people with
            view access. You’ll be notified via email when they forward the
            document.
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    document: { id: docID, documentSettings },
  } = state.DocumentStore;
  return {
    docID,
    documentSettings,
  };
};

const mapDispatchToProps = {
  getDocumentSettingsAction,
  updatedDocumentSettingsAction,
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocumentForwardingSetting);
